class FixedSiteHeader extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    document.addEventListener('load', (e) => {
      this.onWindowLoadPosition(e)
    })

    document.addEventListener('scroll', (e) => {
      this.onWindowScroll(e)
    })

    const toggleMobileMenu = (e) => {
      this.onMobileMenuToggle()
    }

    const mobileMenuButton = document.querySelector('[data-drawers-trigger="menu"]')
    mobileMenuButton.addEventListener('click', toggleMobileMenu)

    const mobileMenuBackground = document.querySelector('[data-site-drawers-el="backdrop"]')
    mobileMenuBackground.addEventListener('click', toggleMobileMenu)
  }

  onWindowLoadPosition(e) {
    const siteBody = document.querySelector('body')
    const announcementBar = document.querySelector('.hd-Announcement')
    const announcementBarHeight = announcementBar.offsetHeight
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if(announcementBar) {
      if (scrollTop > announcementBarHeight) {
        siteBody.classList.add('util-HeaderScroll')
      } else {
        siteBody.classList.remove('util-HeaderScroll')
      }
    } else {
      if (scrollTop > 0 ) {
        siteBody.classList.add('util-HeaderScroll')
      } else {
        siteBody.classList.remove('util-HeaderScroll')
      }
    }
  }

  onWindowScroll(e) {
    const siteBody = document.querySelector('body')
    const announcementBar = document.querySelector('.hd-Announcement')
    const announcementBarHeight = announcementBar.offsetHeight
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if(announcementBar) {
      if (scrollTop > announcementBarHeight) {
        siteBody.classList.add('util-HeaderScroll')
      } else {
        siteBody.classList.remove('util-HeaderScroll')
      }
    } else {
      if (scrollTop > 0 ) {
        siteBody.classList.add('util-HeaderScroll')
      } else {
        siteBody.classList.remove('util-HeaderScroll')
      }
    }
  }

  onMobileMenuToggle () {
    const siteBody = document.querySelector('body')
    siteBody.classList.toggle('util-MobileMenuOpen')
  }
}

customElements.define('fixed-site-header', FixedSiteHeader)
